import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppComponent } from 'src/app/app.component';

interface JsonFormValidators {
  min?: number;
  max?: number;
  required?: boolean;
  requiredTrue?: boolean;
  email?: boolean;
  minLength?: number;
  maxLength?: number;
  pattern?: string;
  nullValidator?: boolean;
  ssn?:boolean;
}
interface JsonFormControlOptions {
  min?: string;
  max?: string;
  step?: string;
  icon?: string;
  showCount?: boolean;
  count?: number;
}
interface JsonFormControls {
  name: string;
  label: string;
  value: any;
  type: string;
  placeholder: string;
  infoText?: string;
  helperText?: string;
  options?: JsonFormControlOptions | any;
  required: boolean;
  validators: JsonFormValidators;
  readonly?: boolean;
  optional?: boolean;
}
export interface JsonFormData {
  controls: JsonFormControls[];
}

@Component({
  selector: 'app-json-preview',
  templateUrl: './json-preview.component.html',
  styleUrls: ['./json-preview.component.css', '../../css/common.css'],
})
export class JsonPreviewComponent implements OnInit {
  @Input()
  formData: FormGroup | any;

  @Input()
  controlsData: JsonFormControls[] = [];

  @Output()
  valueChangeEvent = new EventEmitter<any>();

  @Output() InitializationCompletedEvent = new EventEmitter<any>();
  emailFormat: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  isInvalidEmail: boolean = false;

  @Input()
  isQuePage: boolean = false;

  @Input()
  controlWidth: boolean = false;

  buildConfig2: any;
  IsFroalaEditor: boolean = false;

  @Input()
  textAreaCol: number = 30;

  @Input()
  textAreaRows: number = 3;

  @Input()
  customClass: string = "";

  @Input()
  textAreaCounterPositionClass: string = 'rightFloat';
  @Input()
  showTextInfo: boolean = true;

  zipCodeRegexFormat: RegExp = /^(?:\d{5}|\d{9}|\d{5}-\d{4})$/;
  ssnRegexFormat:RegExp = /^(?:\d{9}|\d{3}-\d{2}-\d{4})$/;

  faxRegexFormat:RegExp = /^(?:\d{10}|\d{3}-\d{3}-\d{4})$/;
  isInvalidFax:boolean = false;
  isCalendarOpen = false;
  
  constructor(
    private fb: FormBuilder,
    private elementRef: ElementRef,
    private appComponent: AppComponent,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
  }


  onDateInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');
    if (value.length >= 3 && value.length <= 4) {
      value = value.substring(0, 2) + '/' + value.substring(2);
    } else if (value.length >= 5) {
      value =
        value.substring(0, 2) +
        '/' +
        value.substring(2, 4) +
        '/' +
        value.substring(4);
    }
    input.value = value;
  }
  
  ngAfterViewInit() {
    const uiElement = this.elementRef.nativeElement.querySelectorAll(
      '.p-datepicker-trigger'
    );
    uiElement.forEach((element: any) => {
      element.setAttribute('aria-label', 'Toggle Datepicker');
      element.setAttribute('title', 'Datepicker');
      element.setAttribute('role', 'button');
    });

    const paragraphs =
      this.elementRef.nativeElement.querySelectorAll('.dynRequired');
    paragraphs.forEach((span: HTMLElement) => {
      this.renderer.setStyle(span, 'font-size', '14px');
      this.renderer.setStyle(span, 'font-weight', 'normal');
    });

    const img = this.elementRef.nativeElement.querySelectorAll('img');
    img.forEach((p: HTMLElement) => {
      p.setAttribute('alt', 'img');
    });
  }

  onCalendarClick() {
    const calendarPrev =
      this.elementRef.nativeElement.querySelector('.p-datepicker-prev');
    const calendarNext =
      this.elementRef.nativeElement.querySelector('.p-datepicker-next');

    if (calendarPrev) {
      calendarPrev.setAttribute('aria-label', 'prevButton');
    }
    if (calendarNext) {
      calendarNext.setAttribute('aria-label', 'nextButton');
    }
  }

  formatDateToMMDDYYYY(value: any, item: any) {
    if (item.value) {
      var value = item.value.toISOString().split('T')[0];
      value.toString();
    }
  }


  onKeyUpEmailFormatEvent(event: any, item: any) {
    const data = {
      value: event,
      name: item.name,
    };
    if (event) {
      event.srcElement.value && !this.emailFormat.test(event.srcElement.value)
        ? (this.isInvalidEmail = true)
        : (this.isInvalidEmail = false);
    }
  }

  onKeyUpFaxEvent(event:any,item:any){
    const data = {
      value: event,
      name: item.name,
    };
    if (event) {
      (event.srcElement.value && !this.faxRegexFormat.test(event.srcElement.value)) 
      ? this.isInvalidFax = true 
      : this.isInvalidFax = false;
    }
  }
}
